module.exports = __webpack_public_path__ + "static/media/supervisor.2eb36c8b.avif";